var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormSelect',{attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"name":_vm.$t('meta.fraction'),"options":_vm.fractionOptions,"required":_vm.required,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }